
export enum OrderCreationStrategy {
  TicketOrder = 'TicketOrder',
  ProductOrder = 'ProductOrder',
  GenericOrder = 'GenericOrder',
}
